import { MetaObjetivo } from "./metaObjetivo";

export class MetaAtendimento {

    id: number;
    metaObjetivo: MetaObjetivo;

}